import React from 'react';

import {
  useTagsState,
  useTagsActions
} from './TagsContext';

import Feedback from '../../Shared/UI/Feedback/components/Feedback';

const TagsFeedback = () => {
  const tagsState = useTagsState();
  const { clearFeedback } = useTagsActions();

  return (
    <Feedback
      message={tagsState?.feedbackMessage}
      variant={tagsState?.feedbackVariant}
      closeFeedback={clearFeedback}
    />
  );
};

export default TagsFeedback;
